import {
  addCandidateToJob,
  addToAnotherJob,
  Button,
  ComponentStyle,
  closeModalUsingState,
  Form,
  Formik,
  FormikControl,
  getCandidateActiveJobList,
  handleSelectJobValueOnChange,
  Image,
  InputError,
  useEffect,
  useState,
  useSWR
} from "@/imports-files/components/add-to-job-modal.js";
import { FormModalStyle } from "@/imports-files/components/review-email";
import {
  INVITE_AGENCY_USER_INITIAL_VALUES,
  INVITE_AGENCY_USER_VALIDATION_SCHEMA,
  shouldRenderSuggestions,
  renderInputComponent,
  getUserSuggestionValue,
  renderUserSuggestion,
  onUserSuggestionsFetchRequested,
  onUserSuggestionsClearRequested,
  isEmail,
  onUserSuggestionSelection,
  handleKeyDown,
  handleEmailDelete,
  PageStyle,
  inviteUsers,
  checkEmailDomain,
  useRef,
} from "@/imports-files/pages/clients/company/invite-agency-users";
import CloseWhite from "public/icons/closewhite.svg";
import Error from "public/icons/error_exclamation.svg";
import CloseBlue from "public/icons/close.svg";
import { Close } from "@/imports-files/components/common-modal/common-modal";
import Modal from "./common-modal/modal";
import { closeJob}  from '@/imports-files/pages/clients/candidates/kanban';
import { Field, TRANSLATION,  Yup} from "@/imports-files/common/common";
import { submitAgencyResponse } from "@/actions/pages/clients/jobs/job-sharing.js"

export function AddNewAgencyUser(props)
{
  const formRef         = useRef();
  const { data, error } = useState();
  const [initialValues, setInitialValues] = useState({
      existing_agency: true,
      agency_id: '',
      agency_name: ''
  });

const schema =
      Yup.object({
        existing_agency: Yup.boolean().nullable(),
        agency_id: Yup.string().when("existing_agency", {
          is: (existing_agency) => existing_agency,
          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(),
          otherwise: Yup.string().notRequired()
        }),
        agency_name: Yup.string().when("existing_agency", {
          is: (existing_agency) => !existing_agency,
          then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(),
          otherwise: Yup.string().notRequired()
        })
      })

  return(
      <Formik
      initialValues={initialValues}
      validationSchema={schema}
      innerRef={formRef}
      onSubmit={async (values) => {
        if (!values.existing_agency) values.agency_id = ''
        await submitAgencyResponse(values, props.addAgencyModal, props.setAddAgencyModal, props.job_id);
      }}
    >
      {(formik) => (
        <>
          <Modal
            type="form"
            heading="Add Agency"
            closeModal={() => {
              props.setAddAgencyModal({ state: false });
            }}
            content={
              <Form>
              <div className={`WrapperRadio w100 mt40 mb20`}>
                  <label className={`Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0`}>
                      <Field type="radio" name="existing_agency" id="option-1" value={true} onChange={(event)=> {
                         formik.setFieldValue("existing_agency", true)
                      }}/>
                    <span className="WrapperRadiocheckmark m0"></span> <span className={`ml5`}>Existing agency</span>
                  </label>

                  <label className={`Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0`}>
                      <Field type="radio" name="existing_agency" id="option-2" value={false} onChange={(event)=> {
                        formik.setFieldValue('existing_agency', false)
                      }}/>
                      <span className="WrapperRadiocheckmark m0"></span> <span className={`ml5`}>Add new agency</span>
                    </label>
              </div>


             {formik.values.existing_agency && (<>
              <div className = {`${FormModalStyle.Modal__Container__ContentSection__Block__Description} mb30`}><p>Choose from the list of your agencies to add this user to.</p></div>
              <label className={FormModalStyle.Modal__Container__ContentSection__Block__Heading}>Select an agency</label>
              <FormikControl className={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto} pb20`}
                            control="select"
                            default={""}
                            formik={formik}
                            name="agency_id"
                            onChange={(option) => formik.setFieldValue("agency_id", option.value)}
                            options={props.agency_list}
                            style={InputError(formik, 'agency_id')}
                            value={props.agency_list.filter(option => option.value === formik.values.agency_id)}
                            disabled={false}
              /><div className="height113 mt9"></div></>)}
             {!formik.values.existing_agency && (<>
              <div className = {`${FormModalStyle.Modal__Container__ContentSection__Block__Description} mb30`}><p>Enter the name of the new agency to be created and associated for this user.</p></div>
              <label className={FormModalStyle.Modal__Container__ContentSection__Block__Heading}>Add new agency</label>
              <FormikControl
                            control="input"
                            type="text"
                            formik={formik}
                            name="agency_name"
                            className={PageStyle.Form__Input}
                            errorClass={PageStyle.Form__Error}
                            style={InputError(formik, "agency_name")}
                            disabled={false}
              /><div className="height113"></div></>)}


              {/* button section */}
                <div className={FormModalStyle.Modal__Container__ButtonSection}>
                  <Button
                    buttonstyle={FormModalStyle.secondarybtn}
                    onClick={() => {
                      props.setAddAgencyModal({ state: false });
                      }}
                  >
                    Cancel
                  </Button>
                  <Button buttonstyle={FormModalStyle.primarybtn} type="submit">
                    Save
                  </Button>
                </div>
              {/* button section */}
              </Form>
            }
          />
        </>
      )}
    </Formik>
  )
}

